import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'How do I receive the product?',
    a: 'Immediately after your purchase you will receive an email with instant download access to all 6 tomes and 5 bonuses. No waiting. No shipping. You can start printing within minutes.'
  }, {
    q: 'What age is this designed for?',
    a: "Megapack Neuro-Kid™ covers ages 3 to 12 with 6 separate tomes, each calibrated to a specific developmental stage. You get everything in one purchase — use the tomes that match your child's age today and unlock the next levels as they grow."
  }, {
    q: 'Do I need teaching experience?',
    a: 'Absolutely not. Every activity comes with clear simple instructions. The Parent Quick-Start Guide walks you through the entire system in 15 minutes. If you can sit next to your child for 10 minutes, you can do this.'
  }, {
    q: 'What if my child has ADHD or learning difficulties?',
    a: 'Megapack Neuro-Kid™ was designed with simplicity and progressive difficulty in mind. Many parents of children with ADHD, sensory sensitivities, and learning differences report it as one of the few activity systems their child actually enjoys and completes. Start with Tome 1 regardless of age to build the habit first.'
  }, {
    q: 'How many children can use this?',
    a: 'One purchase covers your entire family forever. Print as many copies as you need for as many children as you have. There are no restrictions and no additional fees.'
  }, {
    q: 'What makes this different from free worksheets online?',
    a: 'Free worksheets are random. Megapack Neuro-Kid™ is a progressive brain training system. Every activity is sequenced to build on the last one, targeting specific cognitive skills — focus, memory, logic, emotional regulation — in the exact order a developing brain needs. That structure is what creates real lasting results.'
  }, {
    q: 'Does my child need a screen to use this?',
    a: 'Never. Everything is designed to be printed and used with a pencil, crayon, or pen. That is the entire point — your child gets a complete cognitive workout with zero screen time required.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-lightgray py-16 px-4" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-center mb-10 text-navy" data-id="element-60">
          ❓ FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-border rounded-xl overflow-hidden shadow-sm" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-lightgray/50 transition-colors" data-id="element-63">
                <span className="font-heading font-bold text-navy text-base md:text-lg pr-4" data-id="element-64">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-orange transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-65" />
              </button>
              <AnimatePresence data-id="element-66">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-67">
                    <div className="px-6 pb-5 text-muted border-t border-border pt-4 text-sm md:text-base font-medium leading-relaxed" data-id="element-68">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}